import MetricGroupBreakdownCard from '@components/charts/telecom/MetricGroupBreakdown';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import LoadingSpinner from '../../../components/buttons/LoadingSpinner';
import { SimcardService } from '../../../services/simcards/Simcards';
import { RootState } from '../../../state/store';

interface props {
  phoneNumbers: string[];
}

const SimUserUsage = (phoneNumbers: props) => {
  console.log(phoneNumbers);
  const service = new SimcardService();
  const companyId = useSelector(
    (state: RootState) => state.companies.selectedCompany?.id
  );
  const [pieData, setPieData] = useState([]);
  const [notFound, setNotFound] = useState(false);
  const [simData, setSimdata] = useState([]);

  useEffect(() => {
    setPieData([]);
    if (companyId) {
      const fetchData = async () => {
        try {
          const lastUsageDate = await service.getLastMetricsMonth(companyId);
          const res = await service.getBruto(
            {
              years: [lastUsageDate.year],
              months: [lastUsageDate.month],
              metricGroups: [
                'calls',
                'data',
                'mpay',
                'others',
                'sms',
                'subscriptions',
              ],
              ...phoneNumbers,
            },
            companyId
          );

          setPieData(res.results);
          setSimdata(res.results);
        } catch (err) {
          setNotFound(true);
          console.error('Error fetching SIM data:', err);
        }
      };
      fetchData();
    }
  }, [phoneNumbers, companyId]);

  return (
    <>
      {pieData.length > 0 ? (
        <MetricGroupBreakdownCard
          data={{ results: pieData, items: 0, offset: 0, limit: 0 }}
        />
      ) : notFound ? (
        'Geen data gevonden'
      ) : (
        <LoadingSpinner />
      )}
    </>
  );
};

export default SimUserUsage;
